import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="hero-grid flex min-h-[70vh] items-center justify-center px-4 py-16">
      <div className="card-tactical w-full max-w-md p-8 text-center">
        <XCircle className="mx-auto h-14 w-14 text-slate-400" />
        <h1 className="mt-4 text-2xl font-extrabold uppercase">Paiement annulé</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          Aucun montant n'a été débité et le stock n'a pas été réservé.
          Vous pouvez reprendre votre commande quand vous voulez.
        </p>
        <Link to="/boutique" data-testid="payment-cancel-shop-link"
          className="mt-8 inline-block rounded-xl bg-orange-500 px-6 py-3 font-heading text-lg font-bold uppercase tracking-wide text-[#060B18] transition-all hover:scale-[1.02] hover:bg-orange-400 active:scale-[0.98]">
          Retour à la boutique
        </Link>
      </div>
    </div>
  );
}
